import React, { PureComponent } from 'react';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import _isNumber from 'lodash/isNumber';
import _compact from 'lodash/compact';

import ProgressBar from '../Global/ProgressBar';
import FilterNoneIcon from '@material-ui/icons/FilterNone';

import combineStyles from '../../utils/combineStyles';
import TypographyStyles from '../../styles/typography';

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import EProSummaryStyles from './__styles__/EProSummary.styles';

import ConfirmDialogModal from '../Global/Modals/ConfirmDialog';

const SHIPMENT_DIRECTION = {
  INBOUND: 'Inbound',
  OUTBOUND: 'Outbound'
};

export class EProSummary extends PureComponent {
  state = {
    optionsMenu: null,
    openConfirmDeleteNotificationModal: false
  };

  _handleOpenOptionsMenu = event => {
    this.setState({ optionsMenu: event.currentTarget });
  };

  _handleCloseOptionsMenu = () => {
    this.setState({ optionsMenu: null });
  };

  _handleActivateToggle = () => {
    this.props.onActivateToggle(this.props.eProNumber);
  };

  _getLocations = () => {
    const {
      locations,
      eProNumber: { locationInfos }
    } = this.props;

    const locationsSelected = locationInfos.map(locationInfo => {
      const location = locations.find(
        location => parseInt(location.id) === locationInfo.locationId
      );
      const bounds = [
        locationInfo.forInbound ? SHIPMENT_DIRECTION.INBOUND : null,
        locationInfo.forOutbound ? SHIPMENT_DIRECTION.OUTBOUND : null
      ];

      if (location) {
        const boundsCompacted = _compact(bounds);
        return `${location.name} ${
          boundsCompacted.length ? `(${boundsCompacted.join(', ')})` : ''
        }`;
      }
      return '';
    });

    return locationsSelected.join(', ');
  };

  _handleDelete = () => {
    this.props.onDelete(this.props.eProNumber);
  };

  _handleCloseConfirmDeleteNotificationModal = () =>
    this.setState({ openConfirmDeleteNotificationModal: false });

  _handleOpenConfirmDeleteNotificationModal = () =>
    this.setState({ openConfirmDeleteNotificationModal: true });

  render() {
    const { classes, t, theme, eProNumber = {}, isDeleting } = this.props;

    const currentSequence = eProNumber.sequenceInfos.find(
      secuence => !secuence.exhausted
    );

    const { lastValueUsed, sequenceEnd } = currentSequence;
    const value = _isNumber(lastValueUsed) || 0;

    this._getLocations();

    return (
      <div className={classes.root}>
        <div className={classes.iconContainer}>
          <FilterNoneIcon className={classes.icon} />
        </div>
        <div className={classes.details}>
          <p
            className={classnames(classes.subtitle3, classes.eProName, {
              [classes.disabled]: eProNumber.suspended || eProNumber.isDeleted
            })}
          >
            {eProNumber.name}
          </p>
          <p
            className={classnames(classes.body2, {
              [classes.disabled]: eProNumber.suspended || eProNumber.isDeleted
            })}
          >
            {this._getLocations()}
          </p>
          <ProgressBar
            totalValue={sequenceEnd}
            value={value}
            color={
              eProNumber.suspended || eProNumber.isDeleted
                ? theme.palette.disabled.main
                : theme.palette.primary.main
            }
          />
        </div>
        <div className={classes.optionsContainer}>
          <IconButton
            aria-label="options"
            aria-owns={this.state.optionsMenu ? 'long-menu' : undefined}
            aria-haspopup="true"
            onClick={this._handleOpenOptionsMenu}
            className={classes.optionsButton}
          >
            <MoreVertIcon className={classes.optionsIcon} />
          </IconButton>
          <Menu
            id="long-menu"
            anchorEl={this.state.optionsMenu}
            open={Boolean(this.state.optionsMenu)}
            onClose={this._handleCloseOptionsMenu}
            classes={{
              paper: classes.menu
            }}
          >
            <MenuItem
              onClick={this._handleActivateToggle}
              classes={{
                root: classes.menuItemRoot,
                selected: classes.menuItemSelected
              }}
            >
              {eProNumber.suspended ? t('Activate') : t('Deactivate')}
            </MenuItem>
            <MenuItem
              onClick={this._handleOpenConfirmDeleteNotificationModal}
              classes={{
                root: classes.menuItemRoot,
                selected: classes.menuItemSelected
              }}
            >
              {t('Delete')}
            </MenuItem>
          </Menu>
        </div>
        <ConfirmDialogModal
          open={this.state.openConfirmDeleteNotificationModal}
          title={t('Are you sure you want to delete this E-PRO sequence?')}
          message={t('This action cannot be undone.')}
          confirmLabel={t('Delete')}
          onClose={this._handleCloseConfirmDeleteNotificationModal}
          onConfirm={this._handleDelete}
          isSubmitting={isDeleting}
        />
      </div>
    );
  }
}

export default withStyles(combineStyles(EProSummaryStyles, TypographyStyles), {
  withTheme: true
})(withNamespaces()(EProSummary));
